import { render, staticRenderFns } from "./card-review-02.vue?vue&type=template&id=0fbc6645&scoped=true&"
import script from "./card-review-02.vue?vue&type=script&lang=js&"
export * from "./card-review-02.vue?vue&type=script&lang=js&"
import style0 from "./card-review-02.vue?vue&type=style&index=0&id=0fbc6645&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc6645",
  null
  
)

export default component.exports